<template>
  <BaseModal
    v-if="config !== null"
    is-open
    :show-close-button="false"
    @close="close"
  >
    <template #title>
      <div class="flex items-center justify-center flex-col mb-2 w-full">
        <div class="flex items-center justify-center pb-6 im:pb-8 w-full">
          <InfoIcon v-if="config.type === 'info'" class="w-12 h-12 im:w-16 im:h-16 text-red" />
          <WarningIcon v-if="config.type === 'warning'" class="w-12 h-12 im:w-16 im:h-16 text-yellow" />
          <SuccessIcon v-if="config.type === 'success'" class="w-12 h-12 im:w-16 im:h-16 text-green" />
        </div>
        <div class="text-base im:text-2xl leading-6 im:leading-8 text-center mb-3 im:mb-5">
          {{ config?.title }}
        </div>
      </div>
    </template>

    <div class="text-sm leading-5 text-center im:pl-8 im:pr-8">
      {{ config.text }}
    </div>

    <template #actions>
      <div class="w-full flex justify-center items-center">
        <BaseButton
          :color="config.type === 'success' ? 'green' : 'white'"
          class="w-full im:w-40"
          :is-loading="isLoading"
          @click="close"
        >
          {{ config?.button }}
        </BaseButton>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import InfoIcon from '@tagvenue/icons/24/line/alerts-feedback/alert-circle.svg';
import WarningIcon from '@tagvenue/icons/24/line/alerts-feedback/alert-triangle.svg';
import SuccessIcon from '@tagvenue/icons/24/line/general/check-circle.svg';

import BaseButton from '@/components/Ui/Buttons/BaseButton.vue';
import BaseModal from '@/components/Ui/Modals/BaseModal.vue';

export default {
  name: 'EnquirySentModal',
  emits: ['close'],
  components: { BaseButton, BaseModal, InfoIcon, WarningIcon, SuccessIcon },
  props: {
    config: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  watch: {
    config: {
      handler() {
        if (this.config) {
          this.isLoading = false;
        }
      },
      deep: true,
    },
  },
  methods: {
    close() {
      this.isLoading = true;

      if (typeof this.config.onClose === 'function') {
        this.config.onClose();
      }

      this.$emit('close');
    },
  },
};
</script>
